export const EducationData = [
  {
    id: 1,
    degree: "B.Tech",
    institution: "Indian Institute of Information Technology",
    location: "Jabalpur",
    duration: "2017 - 2021",
    cgpa: "8.2",
    description: "Bachelor of Technology in Information Technology with focus on software development, data structures, algorithms, and computer science fundamentals."
  }
];
